import PlayersModal from "./PlayersModal";
import useModal from "../hooks/useModal";
import Player from "./player";
import { useState } from "react";

function PlayersList({players, name, updateRemaining}) {
    const { isShowing, toggle } = useModal();
    const [ state, setArray ] = useState([])

    const selectPlayers = (players) => {
        setArray(players);
        updateRemaining(players, name);
    }

    return (
        <div>
            <h2>{name}</h2>
            <button onClick={toggle}>+</button>
            <PlayersModal players={players} isShowing={isShowing} hide={toggle} playersSelected={selectPlayers}/>
            <ul>
            {
                state.map(player => (
                    <li key={player.id}>
                        <Player player={player} key={player.id}></Player>
                    </li>
                ))
            }
            </ul>
        </div>
    )
}

export default PlayersList;